// Ensure the `monthsFromNow` value as an integer, even if the
// input is in the form of `"8 months"` or `"15 / 3 months"`
module.exports = function getMonthsFromNowNumber(input) {
  const type = typeof input;
  if (type === 'number') {
    return input;
  }
  if (type === 'string') {
    return Number(input.split(' ')[0]);
  }
  throw new TypeError(`getMonthsFromNowNumber expects a string or number, got ${type}`);
};



// WEBPACK FOOTER //
// ./src/modules/getMonthsFromNowNumber.js